import type { PlannerProject, WardrobeModule } from "../types";
import { topFillerMm } from "./installation";
import { moduleElevationMm } from "./moduleRules";
import { getShelvingCellLayouts, getShelvingGridLayout } from "./shelving";

/**
 * Сколько места над фасадом для подъёмника (10.10). HL поднимает фасад выше
 * корпуса, HS кладёт его сверху — им нужно свободное место над корпусом.
 * 0 — сверху стоит антресоль или закрывает верхний добор; Infinity — потолок не задан.
 */
export const moduleHeadroomMm = (project: PlannerProject, module: WardrobeModule) => {
  if (project.modules.some((candidate) => candidate.stackedOnId === module.id)) return 0;
  if (topFillerMm(module) > 0) return 0;
  const ceiling = project.room?.ceilingHeight;
  if (!ceiling || !Number.isFinite(ceiling)) return Infinity;
  return Math.max(0, ceiling - moduleElevationMm(project, module) - module.height);
};

/** Над ячейкой стеллажа: в нижних рядах сверху другая ячейка — места нет. */
export const shelvingCellHeadroomMm = (
  project: PlannerProject,
  module: WardrobeModule,
  cellId: string,
  grid = getShelvingGridLayout(module)
) => {
  const layout = getShelvingCellLayouts(module, grid).find((candidate) => candidate.id === cellId);
  if (!layout || layout.row + layout.rowSpan < grid.rows) return 0;
  return moduleHeadroomMm(project, module);
};
